import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'

export const useNewsContent = () => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const handleFavoriteClick = (news_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: news_id,
          type: 'novelty'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id: news_id,
          type: 'novelty'
        })
      )
    }
    return state
  }

  return {
    t,
    handleFavoriteClick
  }
}
